import { render } from "./AddEntitlement.vue?vue&type=template&id=31b0da72&scoped=true"
import script from "./AddEntitlement.vue?vue&type=script&lang=js"
export * from "./AddEntitlement.vue?vue&type=script&lang=js"

import "./AddEntitlement.vue?vue&type=style&index=0&id=31b0da72&lang=scss&scoped=true"
import "./add-entitlement.scss?vue&type=style&index=1&id=31b0da72&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b0da72"]])

export default __exports__